import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  h2 {
    margin: 30px 0;
  }
`;

export default GlobalStyle;